import { css } from '@emotion/react';
import { semantic_colors, shapes, text_styles } from '../../foundation';

export const breadcrumb_item_link_css = css`
  ${shapes.border_radius.xsmall};
  transition: background-color 0.1s linear, color 0.1s linear;
  cursor: pointer;
  &:hover {
    background-color: #f7f7f7;
    color: ${semantic_colors.content.primary};
  }
  &:active {
    background: #f0f0f0;
    color: ${semantic_colors.content.primary};
  }
  &:hover .pds-breadcrumb-icon path,
  &:active .breadcrumb-icon path {
    fill: ${semantic_colors.content.primary};
  }
`;

export const breadcrumb_item_base_css = css`
  ${text_styles.Body_13_Medium};
  color: ${semantic_colors.content.tertiary};
  display: inline-flex;
  align-items: center;
  text-align: center;
  list-style: none;
  line-height: 13px;
  height: 22px;
  padding: 0 4px;
  .pds-breadcrumb-icon path {
    fill: ${semantic_colors.content.tertiary};
  }
  a {
    display: inline-flex;
    align-items: center;
    min-height: 22px;
    outline: none;
    text-decoration: none;
    color: inherit;
  }
  :has(a) {
    ${breadcrumb_item_link_css}
  }
`;

export const breadcrumb_item_selected_css = css`
  color: ${semantic_colors.content.primary};
`;

export const breadcrumb_item_disabled_css = css`
  opacity: 0.4;
  cursor: not-allowed;
`;
